import apiClient from '../apiClient';
import { POST_ADDITIONAL_INFO_PACKAGE_URL } from '../apiUrl';

const postAdditionalInfoApi = data => {
  return apiClient.post(POST_ADDITIONAL_INFO_PACKAGE_URL, data);
};

export default postAdditionalInfoApi;
